// ─────────────────────────────────────────────────────────────────────────────
// KEYBOARD OR POINTER? (UI-1, the focus ring in src/ui/foundation.css)
//
// The ring shows only while the person is using the keyboard to move around. Tab
// (with or without Shift) switches it on; any mouse, pen or touch switches it off.
// Typing inside a field does not switch it on: only Tab does, because Tab is how
// focus moves. Returns a function that removes the listeners (for tests).
// ─────────────────────────────────────────────────────────────────────────────

export function initFocusModality(doc = typeof document !== 'undefined' ? document : undefined) {
  if (!doc || !doc.documentElement) return () => {};
  const root = doc.documentElement;
  const onKey = (e) => { if (e.key === 'Tab') root.setAttribute('data-keyboard', ''); };
  const onPointer = () => root.removeAttribute('data-keyboard');
  doc.addEventListener('keydown', onKey, true);
  doc.addEventListener('pointerdown', onPointer, true);
  doc.addEventListener('mousedown', onPointer, true);
  doc.addEventListener('touchstart', onPointer, { capture: true, passive: true });
  return () => {
    doc.removeEventListener('keydown', onKey, true);
    doc.removeEventListener('pointerdown', onPointer, true);
    doc.removeEventListener('mousedown', onPointer, true);
    doc.removeEventListener('touchstart', onPointer, { capture: true });
    root.removeAttribute('data-keyboard');
  };
}
